import React, { useEffect, useState } from "react";
import { URLS } from "../Services/Constant";
import { get } from "../Services/ApiHandler";
import Loader from "../Component/Loader";
import useStore from "../LocalStore/useStore";
import { useLocation } from "react-router-dom";

const PriceList = () => {
  const [loading, setLoading] = useState(false);
  const { kv, set } = useStore();
  const game = kv.game || [];
  const [gameData, setGameData] = useState(game);

  const location = useLocation();

  useEffect(() => {
    const fromFooter = location.state?.fromFooter;

    if (fromFooter) {
      if (location.state?.fromFooter) {
        setTimeout(() => {
          const el = document.querySelector(".dashRightView-foot"); // 👈 your scroll container
          if (el) {
            el.scrollTo({ top: 0, behavior: "smooth" });
          }
        }, 0);
        getList();
      }
    }
  }, [location]);

  const getList = async () => {
    try {
      // // console.log("game", game);
      if (!game || game.length == 0) {
        setLoading(true);
      }
      const res = await get(`${URLS.PRICELIST}`);
      // // console.log("Fetched data:", res);

      if (res?.status === "success" && Array.isArray(res?.data)) {
        setGameData(res?.data);
        set("game", res?.data);
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  const threegame = gameData[2];

  const fourgame = gameData[3];

  return (
    <div
      className="dashRightView-foot"
      style={{
        gap: 10,
        display: "flex",
        flexDirection: "column",
        paddingBottom: 90,
      }}
    >
      <p className="game-desc">
        This 4 & 3 digit game is based on the daily result of Kerala & Dear
        lottery first prize reults with the last 4 & 3 digits based.
      </p>
      <h5 className="game-title">Kerala [Upto 4 digits game]</h5>
      <h2 className="bluetext">3:00 PM</h2>
      <p className="paratext">
        An example of a first price ticket is 5635
        X=5, A=6, B=3, C=5, AB=63, BC=35, AC=65, ABC = 635, XABC = 5635
      </p>

      <h5 className="game-title">Dear [Upto 3 digits game]:</h5>
      <h2 className="bluetext">01:00 PM, 06:00 PM & 08:00 PM</h2>
      <p className="paratext">
        An example of a first price ticket is 062
        A=0, B=6, C=2, AB=06, BC=62, AC=02, ABC = 062
      </p>

      <h5 className="game-title">Single Digit Game - A, B, C Board</h5>
      <p className="game-desc">
        Single digit games can be played on any board between A, B and C.
      </p>

      {gameData[0]?.variations?.map((item, index) => (
        <div key={item.fee_price_id || index} className="game-card">
          <div className="ticket-header">
            <span>Ticket Price: {item.ticket_price}</span>
          </div>

          <table
            className="ticket-table1"
            style={{ tableLayout: "fixed", width: "100%" }}
          >
            <thead>
              <tr>
                {item.combinations?.map((combination, i) => (
                  <th
                    key={i}
                    style={{
                      width: `${100 / item.combinations.length}%`,
                    }}
                  >
                    {combination.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                {item.combinations?.map((combination, i) => (
                  <td
                    key={i}
                    style={{
                      width: `${100 / item.combinations.length}%`,
                    }}
                  >
                    {combination.price}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      ))}

      <h5 className="game-title">Double Digit Game - AB, BC, AC</h5>
      <p className="game-desc">
        In a double digit game, players can pick two numbers in the last three
        digits of the result in the combination of AB, BC and AC.
      </p>
      {/* TWO DIGIT GAME */}
      {gameData[1]?.variations?.map((item, index) => (
        <div key={item.fee_price_id || index} className="game-card">
          <div className="ticket-header">
            <span>Ticket Price: {item.ticket_price}</span>
          </div>

          <table
            className="ticket-table1"
            style={{ tableLayout: "fixed", width: "100%" }}
          >
            <thead>
              <tr>
                {item.combinations?.map((combination, i) => (
                  <th
                    key={i}
                    style={{
                      width: `${100 / item.combinations.length}%`,
                    }}
                  >
                    {combination.name}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              <tr>
                {item.combinations?.map((combination, i) => (
                  <td
                    key={i}
                    style={{
                      width: `${100 / item.combinations.length}%`,
                    }}
                  >
                    {combination.price}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      ))}
      <h5 className="game-title">Three Digit Game - ABC</h5>
      <p className="game-desc">
        If a player places a bet on an ABC 3 digit game in a particular lottery
        there is a three chance of winning.
      </p>
      {/* THREE DIGIT GAME */}
      {threegame?.variations?.filter((ticket) => ticket.fee_price_id !== 4).map((item, index) =>
        
          <div key={item.fee_price_id || index} className="game-card mt-2">
            <div className="ticket-header">
              <span>Ticket Price: {item.ticket_price}</span>
            </div>

            <table
              className="ticket-table1"
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <thead>
                <tr>
                  {Array.from(
                    new Set(item.combinations.map((c) => c.name)),
                  ).map((name, i) => (
                    <th
                      key={i}
                      style={{
                        width: `${100 /
                          Array.from(
                            new Set(item.combinations.map((c) => c.name)),
                          ).length
                          }%`,
                      }}
                    >
                      {name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {Array.from(
                    new Set(item.combinations.map((c) => c.name)),
                  ).map((name, i) => {
                    const val = item.combinations.find((c) => c.name === name);
                    return (
                      <td
                        key={i}
                        style={{
                          width: `${100 /
                            Array.from(
                              new Set(item.combinations.map((c) => c.name)),
                            ).length
                            }%`,
                        }}
                      >
                        {val?.price}
                      </td>
                    );
                  })}
                </tr>
              </tbody>
            </table>
          </div>
        ,
      )}

      <h5 className="game-title">Three Digit Game - ABC</h5>
      <p className="game-desc">
        If a player places a bet on an ABC 3 digit game in a particular lottery
        there is a two chance of winning.
      </p>
      {threegame?.variations?.filter((ticket) => ticket.fee_price_id === 4).map((item, index) =>
        
          <div key={item.fee_price_id || index} className="game-card mt-2">
            <div className="ticket-header">
              <span>Ticket Price: {item.ticket_price}</span>
            </div>

            <table
              className="ticket-table1"
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <thead>
                <tr>
                  {Array.from(
                    new Set(item.combinations.map((c) => c.name)),
                  ).map((name, i) => (
                    <th
                      key={i}
                      style={{
                        width: `${100 /
                          Array.from(
                            new Set(item.combinations.map((c) => c.name)),
                          ).length
                          }%`,
                      }}
                    >
                      {name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {Array.from(
                    new Set(item.combinations.map((c) => c.name)),
                  ).map((name, i) => {
                    const val = item.combinations.find((c) => c.name === name);
                    return (
                      <td
                        key={i}
                        style={{
                          width: `${100 /
                            Array.from(
                              new Set(item.combinations.map((c) => c.name)),
                            ).length
                            }%`,
                        }}
                      >
                        {val?.price}
                      </td>
                    );
                  })}
                </tr>
              </tbody>
            </table>
          </div>
        
      )}
      <h5 className="game-title">Four Digit Game - XABC</h5>
      <span style={{ fontWeight: 600, color: "#8F0D3d" }}>
        This one available only in Kerala Lottery.
      </span>
      <p className="game-desc">
        If a player places a bet on an XABC 4 digit game in a particular lottery
        there is a 4 chance of winning.
      </p>
      <p className="game-desc">
        (XABC Matching or ABC Matching or BC Matching or C Matching)
      </p>

      {fourgame?.variations?.map((item, index) =>
        index !== 0 ? (
          <div key={item.fee_price_id || index} className="game-card mt-2">
            <div className="ticket-header">
              <span>Ticket Price: {item.ticket_price}</span>
            </div>

            <table
              className="ticket-table1"
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <thead>
                <tr>
                  {Array.from(
                    new Set(item.combinations.map((c) => c.name)),
                  ).map((name, i) => (
                    <th key={i}>{name}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {Array.from(
                    new Set(item.combinations.map((c) => c.name)),
                  ).map((name, i) => {
                    const val = item.combinations.find((c) => c.name === name);
                    return <td key={i}>{val?.price}</td>;
                  })}
                </tr>
              </tbody>
            </table>
          </div>
        ) : null,
      )}

      <h5 className="game-title">Four Digit Game - XABC</h5>
      <span style={{ fontWeight: 600, color: "#8F0D3d" }}>
        This is available in Dear and Kerala Lottery.
      </span>
      <p className="game-desc">
        If a player places a bet on an XABC 4 digit game in a particular lottery
        there is a one chance of winning only in four digit winning
      </p>
      {fourgame?.variations?.map((item, index) =>
        index == 0 ? (
          <div key={item.fee_price_id || index} className="game-card mt-2">
            <div className="ticket-header">
              <span>Ticket Price: {item.ticket_price}</span>
            </div>

            <table
              className="ticket-table1"
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <thead>
                <tr>
                  {Array.from(
                    new Set(item.combinations.map((c) => c.name)),
                  ).map((name, i) => (
                    <th key={i}>{name}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  {Array.from(
                    new Set(item.combinations.map((c) => c.name)),
                  ).map((name, i) => {
                    const val = item.combinations.find((c) => c.name === name);
                    return <td key={i}>{val?.price}</td>;
                  })}
                </tr>
              </tbody>
            </table>
          </div>
        ) : null,
      )}
      {loading && <Loader />}
    </div>
  );
};

export default PriceList;
